<template>
    <div class="popup popup--mini" @mousedown.self="$emit('close')">
        <div class="popup__block">
            <div class="popup__top">
                <div class="popup__title">Добавить новую ЕТУ в позиции?</div>
                <div class="popup__close" @click="$emit('close')"></div>
            </div>
            <div class="popup__content">
                <div class="popup__btns">
                    <button class="btn btn--color" @click="$emit('sendForm')">Да, добавить</button>
                    <button class="btn btn--border" @click="$emit('close')">Нет</button>
                </div>
            </div>
        </div>
    </div>
</template>
<script>

export default {
    name: 'ConfirmAddEtuPopup',
    emits: ['close', 'sendForm'],
}
</script>
